// extracted by mini-css-extract-plugin
export var box = "MobileMenu-module--box--dffbc";
export var box_md = "MobileMenu-module--box_md--6b6d1";
export var box_xmd = "MobileMenu-module--box_xmd--f9d01";
export var box_flex = "MobileMenu-module--box_flex--74176";
export var box_lg = "MobileMenu-module--box_lg--e9c04";
export var box_sm = "MobileMenu-module--box_sm--7c234";
export var box_outer = "MobileMenu-module--box_outer--a173b";
export var box_whiteBg = "MobileMenu-module--box_white-bg--423a8";
export var box_noMarginBottom = "MobileMenu-module--box_no-margin-bottom--a6d0f";
export var box_noPadding = "MobileMenu-module--box_no-padding--cb527";
export var box_outerGray = "MobileMenu-module--box_outer-gray--3909b";
export var box_dark = "MobileMenu-module--box_dark--b6386";
export var box_zIndex = "MobileMenu-module--box_z-index--3e940";
export var box_zIndex6 = "MobileMenu-module--box_z-index-6--1399d";
export var box_eventsWithLine = "MobileMenu-module--box_events-with-line--4e850";
export var box_featuresAo = "MobileMenu-module--box_features-ao--89ea3";
export var box_verticalPaddings = "MobileMenu-module--box_vertical-paddings--fbff8";
export var clearP = "MobileMenu-module--clearP--2d1d9";
export var clearP_vc = "MobileMenu-module--clearP_vc--8d2de";
export var mobileMenu = "MobileMenu-module--mobileMenu--8993f";
export var active = "MobileMenu-module--active--ee3fc";
export var container = "MobileMenu-module--container--9a33c";
export var buttonLine = "MobileMenu-module--buttonLine--c39e6";
export var button = "MobileMenu-module--button--19ec8";
export var de = "MobileMenu-module--de--f3245";
export var fadeInAnimation = "MobileMenu-module--fadeInAnimation--640a1";
export var placeHolderShimmer = "MobileMenu-module--placeHolderShimmer--91680";